const en = {
    "1": "Personal Information",
    "2": "User information",
    "3": "User name",
    "4": "Name surname",
    "5": "Email",
    "6": "Change password",
    "7": "Old Password",
    "8": "New Password",
    "9": "New Password (Repetition)",
    "10": "Change password",
    "11": "Customers",
    "12": "Add Customer",
    "13": "Male",
    "14": "Woman",
    "15": "I dont want to declare",
    "16": "Name",
    "17": "Last name",
    "18": "Date of Birth",
    "19": "Password",
    "20": "Add",
    "21": "Balance",
    "22": "Last Login Date",
    "23": "Deposit",
    "24": "Withdraw",
    "25": "Coupons",
    "26": "No",
    "27": "Status",
    "28": "Amount",
    "29": "Earning",
    "30": "Date",
    "31": "Reports",
    "32": "Show",
    "33": "There is no customer record!",
    "34": "There is no coupon!",
    "35": "Dealer Information",
    "36": "Remaining limit",
    "37": "Dealer address",
    "38": "Sport",
    "39": "Commissions",
    "40": "Poker",
    "41": "Affiliate Panel",
    "42": "Login",
    "43": "You cannot enter the game due to the bonus you received!",
    "44": "Play Now",
    "45": "Deposit",
    "46": "Your money deposit process has reached us. It will be uploaded to your account as soon as possible.",
    "47": "Processing fee",
    "48": "Processing time",
    "49": "Processing Limits",
    "50": "Bank",
    "51": "Customer note",
    "52": "Approve",
    "53": "Posted by number",
    "54": "Receiving number",
    "55": "Check it",
    "56": "Bitcoin Address",
    "57": "Dogecoin address",
    "58": "Litecoin Address",
    "59": "Send request",
    "60": "Casino history",
    "61": "There is no casino game record yet!",
    "62": "Game",
    "63": "Coupon history",
    "64": "You do not have a coupon record yet!",
    "65": "Financial history",
    "66": "There is no transaction record yet!",
    "67": "Type",
    "68": "Pending",
    "69": "Approved",
    "70": "It is cancelled",
    "71": "Withdraw",
    "72": "Waiting for results",
    "73": "Lost",
    "74": "Won",
    "75": "To experience this privilege,",
    "76": "Sign Up Now",
    "77": "Sports Bahisi Limits",
    "78": "Minimum deposit",
    "79": "Maximum Deposit",
    "80": "Maximum gain",
    "81": "Daily play limit",
    "82": "Limits",
    "83": "Coupon",
    "84": "You cant bet because of the bonus you have received for Casino!",
    "85": "Mobile pleasure",
    "86": "With its simple and stylish design, you will enjoy betting and casino everywhere with internet connection, which offers users the opportunity to make instant betting or playing casino.",
    "87": "Instant membership",
    "88": "Live",
    "89": "Casino",
    "90": "Sports and live bets, live casino and hundreds of slots, all other transactions with a single key on mobile!",
    "91": "Identification number",
    "92": "Mobile phone",
    "93": "City",
    "94": "Address",
    "95": "Password (Again)",
    "96": "E-mail again)",
    "97": "I want!",
    "98": "I dont want a bonus!",
    "99": "Promotions",
    "100": "By ticking this box to register on this website, I confirm that I am at least 18 years old and that I have read and agree to the <a class=\"active\" target=\"_blank\" href=\"/page/termsconditions\">Terms and Conditions</a>.",
    "101": "Sign up",
    "102": "I accept that the information I gave above is correct.",
    "103": "SLOT search",
    "104": "Choose a country",
    "105": "categories",
    "106": "Search",
    "107": "Team Name ...",
    "108": "Popular Leagues",
    "109": "Dont show again!",
    "110": "Remember me",
    "111": "Register",
    "112": "Sport",
    "113": "Live",
    "114": "Casino",
    "115": "Slot",
    "117": "Bonuses",
    "118": "Log out",
    "119": "Register",
    "120": "My account",
    "121": "Login",
    "122": "Mobile",
    "123": "Bonus",
    "124": "Hello",
    "125": "There is no live match match that starts!",
    "126": "Live",
    "127": "Accurate shot",
    "128": "Unknown shot",
    "129": "Total attack",
    "130": "Dangerous attack",
    "131": "You need to log in to create a coupon!",
    "132": "Coupon not found!",
    "133": "Encounter",
    "134": "Bet",
    "135": "Ratio",
    "136": "Coupon amount",
    "137": "Total earnings",
    "138": "Encounters",
    "139": "Approaching encounters",
    "140": "Your coupon has a varying or removed ratio!",
    "141": "Choose the bet to create a coupon!",
    "142": "Total",
    "143": "Customer",
    "144": "Total betting",
    "145": "Your amount must be greater than 0!",
    "146": "The amount you want to shoot is lower than the customer balance!",
    "147": "You cant add more money than your limit! Your remaining limit:",
    "148": "Please fill out all fields!",
    "149": "Use 8-256 characters. Uppercase letters, lowercase letters, numbers and symbols are optional.",
    "150": "You have written an invalid email address!",
    "151": "There is a similar record to this information!",
    "152": "You have written your current password incorrectly!",
    "153": "Incorrect username or password!",
    "154": "You cannot make money when you have a waiting financial transaction. Please wait for it to end!",
    "155": "The amount you want to shoot is lower than your balance!",
    "156": "IBAN and the account number cannot be empty!",
    "157": "The account number cannot be empty!",
    "158": "You cannot draw less than the minimum withdrawal amount!",
    "159": "You cannot pull more than the maximum withdrawal amount!",
    "160": "You cannot give a request for withdraw because it is a bonus defined in your account!",
    "161": "You cannot invest in money while you have a waiting financial transaction. Please wait for it to end!",
    "162": "Cepbank information cannot be empty!",
    "163": "You cannot deposit less than the minimum deposit amount!",
    "164": "You cannot deposit more than the maximum deposit amount!",
    "165": "In order to create a coupon, you must first login!",
    "166": "I accept the rate changes!",
    "167": "Approve",
    "168": "Clean",
    "169": "Your coupon is deposited. Do you confirm?",
    "170": "Yes",
    "171": "No",
    "172": "Fireplace",
    "173": "February",
    "174": "March",
    "175": "April",
    "176": "May",
    "177": "June",
    "178": "July",
    "179": "August",
    "180": "September",
    "181": "October",
    "182": "November",
    "183": "December",
    "184": "Your balance is not enough for the coupon amount!",
    "185": "Your daily coupon playing limit is insufficient!",
    "186": "Please add at least one encounter!",
    "187": "Your coupon has a ratio type removed!",
    "188": "There is a league removed in your coupon!",
    "189": "There is a country that has been removed in your coupon!",
    "190": "Your coupon has a sport removed!",
    "191": "In accordance with the bonus rules, the total ratio of your coupon cannot be less than a minimum!",
    "192": "Your coupon has a varying or removed live match ratio!",
    "193": "There is a match that ends in your coupon or removed from the fixture!",
    "194": "Your coupon amount must be between minimum and maximum amount!",
    "195": "Maximum betting limit!",
    "196": "Your password and password are not the same!",
    "197": "Your email and email is not the same!",
    "198": "You wrote a wrong TC ID number! Please take care to write your name, surname and date of birth in the right and if you have a Turkish character in your name!",
    "199": "Identity No Field Empty Not Empty!",
    "200": "You need to accept that you read the rules!",
    "201": "E -mail address, user name or TC Identity Number is registered with a member!",
    "202": "Host / host",
    "203": "Host / Together",
    "204": "Host / away",
    "205": "Draw / host",
    "206": "Together / Together",
    "207": "Draw / away",
    "208": "Away / host",
    "209": "Displacement / draw",
    "210": "Displacement / displacement",
    "211": "Homeowner",
    "212": "Tie",
    "213": "Away",
    "214": "Host or togetherness",
    "215": "Host or displacement",
    "216": "Displacement or togetherness",
    "217": "Top",
    "218": "Lower",
    "219": "Goal",
    "220": "Fast Deposit",
    "221": "Only",
    "222": "Couple",
    "223": "1. half",
    "224": "2nd half",
    "225": "1. No goal",
    "226": "2. No goal",
    "227": "3. No goal",
    "228": "4. No goal",
    "229": "5. No goal",
    "230": "6. No Goals",
    "231": "7. No goals",
    "232": "8. No goals",
    "233": "9. No goals",
    "234": "10. No goals",
    "235": "Integer",
    "236": "No goals",
    "237": "IBAN",
    "238": "1st set",
    "239": "2nd set",
    "240": "SET 3.",
    "241": "4th set",
    "242": "5th set",
    "243": "1. half",
    "244": "2nd half",
    "245": "1st quarter",
    "246": "2nd quarter",
    "247": "3. quarter",
    "248": "4. quarter",
    "249": "Extension",
    "250": " or ",
    "251": "Your request for withdraw has reached us.",
    "252": "Branch code",
    "253": "Account number",
    "254": "Latest winners",
    "255": "Coupon detail",
    "256": "High rates",
    "257": "Score",
    "258": "The account is locked!",
    "259": "Homepage",
    "260": "Profit",
    "261": "System notification",
    "262": "Please try your choice again as a combined coupon",
    "263": "Please try your choice again as a single coupon",
    "264": "You do not have casino entry authority!",
    "265": "You do not have a slot login authority!",
    "267": "You do not have the authority to send an deposit request!",
    "268": "You do not have the authority to send a request!",
    "269": "Registration Date",
    "270": "Last Login Date",
    "271": "New Customers",
    "272": "Single",
    "273": "Combined",
    "274": "You entered a wrong phone number!",
    "275": "You entered a wrong TC ID number!",
    "276": "Not found a registered member with the email address!",
    "277": "Football",
    "278": "Basketball",
    "279": "Tennis",
    "280": "Volleyball",
    "281": "Bingo",
    "282": "I forgot my password",
    "283": "The password recovery link has been sent to your email.",
    "284": "History",
    "285": "There were no results!",
    "286": "Turn back",
    "287": "All",
    "288": "Favorites",
    "289": "Match result",
    "290": "1. Circuit",
    "291": "2. Circuit",
    "292": "Close",
    "293": "Your application request has reached us. The authorized personnel will return to you as soon as possible.",
    "294": "Those under the age of 18 cannot register!",
    "295": "You entered a faulty birth date format! (Example 25/08/1980)",
    "296": "You have an unsafe internet connection. Please try with a different internet.",
    "297": "You cant get it again because youve got a bonus before!",
    "298": "Your application request has been received before!",
    "299": "For casino games, you need to log in first!",
    "300": "No account registered to the email address was found!",
    "301": "Faulty password replacement connection",
    "302": "Your new password and password is not the same!",
    "303": "Your current password is wrong",
    "304": "Your balance is not suitable for the coupon amount",
    "305": "There are inactive bets on your coupon",
    "306": "You need to log in to get a bet",
    "307": "You have to bet first to save the coupon",
    "308": "Please try your choice again as a combined coupon!",
    "309": "Please try your choice again as a combined coupon.",
    "310": "You cant bet because you get a casino bonus",
    "311": "Your minimum ratio is not enough due to bonus rules",
    "312": "You cannot bet on the non -existing ratio type",
    "313": "You cannot bet on the league that is not available",
    "314": "You cannot bet on the country that is not available",
    "315": "You cannot bet on the type of sports that are not available",
    "316": "You cannot bet on the non -existing encounter",
    "317": "Minimum Single Ratio Limit is not suitable",
    "318": "Minimum combined ratio limit is not suitable",
    "319": "The ratio limit is not suitable for minimum combination",
    "320": "You have exceeded the maximum combined betting limit",
    "321": "Your minimum coupon amount is not suitable",
    "322": "Your maximum coupon amount is not suitable",
    "323": "Ratio type limit is not suitable",
    "324": "The league limit is not suitable",
    "325": "The encounter limit is not suitable",
    "326": "The encounter is not suitable for betting",
    "327": "Rates have changed, you need to accept up -to -date rates!",
    "328": "Prematch",
    "329": "You can only view the last 100 coupons.",
    "330": "You can only view the last 100 records.",
    "331": "Before",
    "332": "After",
    "333": "The maximum earning limit is not suitable!",
    "334": "Your password has been changed",
    "335": "Change",
    "336": "Providers",
    "338": "Send",
    "339": "Waiting",
    "340": "Loser",
    "341": "Winning",
    "342": "Cancel",
    "343": "",
    "344": "",
    "345": "Sign Up Now",
    "346": "Get ads",
    "347": "Start the promotion",
    "348": "Earn money",
    "349": "",
    "350": "Dealer Registration",
    "351": "Partnership",
    "352": "Gender",
    "353": "minute",
    "354": "hour",
    "355": "Print",
    "356": "Your coupon was successfully saved",
    "357": "Hide",
    "358": "Rates Off",
    "359": "Betting service is not active right now!",
    "360": "Casino service is not active right now!",
    "361": "Slot service is not active right now!",
    "362": "Today",
    "363": "Tomorrow",
    "364": "Deposit",
    "365": "Withdraw",
    "366": "Bonus",
    "367": "Dealer deposit money",
    "368": "DEALER MONEY DRAW",
    "369": "Fix the balance",
    "370": "Install credit",
    "371": "Credit collection",
    "372": "Manual deposit",
    "373": "MANUEL MONEY DRAW",
    "374": "Casino betting",
    "375": "Casino earnings",
    "376": "Casino Cancellation",
    "377": "Coupon betting",
    "378": "Coupon earnings",
    "379": "Coupon Cancellation",
    "380": "Allowed",
    "382": "He doesnt go to goals",
    "383": "None",
    "385": "IN",
    "386": "Circuit",
    "387": "Period",
    "388": "UEFA Champions League",
    "389": "UEFA Europa League",
    "390": "Virtual",
    "391": "System",
    "392": "You need to choose the system type!",
    "393": "Live narrative",
    "394": "Statistics",
    "395": "TV Games",
    "396": "Zeppelin",
    "397": "s",
    "398": "They will be played soon",
    "399": "Are you a registered user? Login by clicking here",
    "400": "Races",
    "401": "Bigbang",
    "402": "Show more",
    "403": "Casino providers",
    "404": "Payment methods",
    "405": "Live casino games",
    "406": "Slot Games",
    "407": "Total ##x## results found.",
    "408": "Coupon exchange",
    "409": "The Cashout Tutari changed or closed! Try again.",
    "410": "Cashout was realized!",
    "411": "Do you approve the coupon exchange process?",
    "412": "Bet",
    "413": "Live",
    "414": "Live casino",
    "415": "Slot",
    "416": "Virtual",
    "417": "Bingo",
    "418": "Tvoyunları",
    "419": "Races",
    "420": "Promotion",
    "421": "Please close the page from the right X sign on the right!",
    "1165": "Homepage",
    "1166": "Customers",
    "1167": "Finance",
    "1168": "Deposit",
    "1169": "Withdraw",
    "1170": "Transactions",
    "1171": "Bet",
    "1172": "Coupons",
    "1173": "Conclusion",
    "1174": "Live",
    "1175": "Prematch",
    "1176": "Limitation",
    "1177": "Risk",
    "1178": "The only match is left",
    "1179": "Open bets",
    "1180": "Encounters",
    "1181": "Reports",
    "1182": "Casino",
    "1183": "Finance",
    "1184": "Daily",
    "1185": "Country/League",
    "1186": "Ratio types",
    "1187": "Games",
    "1188": "Slot",
    "1189": "Payment Methods",
    "1190": "Affiliates",
    "1191": "Bonus",
    "1192": "Credit",
    "1193": "Contents",
    "1194": "Announcements",
    "1195": "Pages",
    "1196": "Promotions",
    "1197": "Headline/Slider",
    "1198": "Templates",
    "1199": "IP Prohibition",
    "1200": "History",
    "1201": "Staff",
    "1202": "Settings",
    "1203": "User or coupon",
    "1204": "User name",
    "1205": "Password",
    "1206": "Login",
    "1207": "Log out",
    "1208": "Rescue code",
    "1209": "Approve",
    "1210": "Refresh",
    "1211": "Profit",
    "1212": "Balance",
    "1213": "Entry today",
    "1214": "Total Customer",
    "1215": "Total",
    "1216": "Total deposit",
    "1217": "Total earnings",
    "1218": "Open Coupon",
    "1219": "CANCEL Coupon",
    "1220": "Total coupon",
    "1221": "Average",
    "1222": "Number of hands",
    "1223": "Name",
    "1224": "New Customers",
    "1225": "Date of registration",
    "1226": "Active Customers",
    "1227": "Customer Notes",
    "1228": "All",
    "1229": "note",
    "1230": "History",
    "1231": "Coupon detail",
    "1232": "Ratio",
    "1233": "Earning",
    "1234": "Amount",
    "1235": "Waiting",
    "1236": "Lost",
    "1237": "Won",
    "1238": "It is cancelled",
    "1239": "Encounter",
    "1240": "Bet",
    "1241": "Vote",
    "1242": "Score",
    "1243": "Available",
    "1244": "Conclusion date",
    "1245": "Add Customer",
    "1246": "No",
    "1247": "Surname",
    "1248": "Email",
    "1249": "Telephone",
    "1250": "Status",
    "1251": "Active",
    "1252": "Passive",
    "1253": "ID Number",
    "1254": "Last Entry Date",
    "1255": "Add",
    "1256": "Approved",
    "1257": "Rejected",
    "1258": "Waiting",
    "1259": "Customer Notification Message",
    "1260": "Approval",
    "1261": "Rejection",
    "1262": "Details",
    "1263": "Type",
    "1264": "Manual Money Uploading",
    "1265": "Manual withdrawal",
    "1266": "Loan loading",
    "1267": "Loan payment",
    "1268": "Coupon Creation",
    "1269": "Coupon earnings",
    "1270": "Casino betting",
    "1271": "Casino earnings",
    "1272": "Dealer Money Loading",
    "1273": "Dealer withdrawal",
    "1274": "Before",
    "1275": "Next",
    "1276": "Single",
    "1277": "Combined",
    "1278": "Betting type",
    "1279": "History Type",
    "1280": "Creation",
    "1281": "Conclusion",
    "1282": "Game",
    "1283": "Total waiting",
    "1284": "Winning coupon",
    "1285": "Losing coupon",
    "1286": "CANCELED/RETURNED",
    "1287": "Possible payment",
    "1288": "Total winner",
    "1289": "Totality",
    "1290": "Total refund",
    "1291": "Remaining",
    "1292": "Site name",
    "1293": "Site address",
    "1294": "Site title",
    "1295": "Site Description",
    "1296": "Keywords",
    "1297": "E-mail address",
    "1298": "Facebook",
    "1299": "twitter",
    "1300": "Instagram",
    "1301": "Default language",
    "1302": "Google Authenticator",
    "1303": "Edit ID Number",
    "1304": "Live support address",
    "1305": "Minimum coupon amount",
    "1306": "Maximum coupon amount",
    "1307": "Select withdrawal method",
    "1308": "Maximum bet (encounter)",
    "1309": "Maximum Betting (League)",
    "1310": "Maximum bet (ratio type)",
    "1311": "Daily limit",
    "1312": "Minimum Single Ratio",
    "1313": "Minimum combined ratio",
    "1314": "Minimum Combined Single Ratio",
    "1315": "Maximum Combine Number",
    "1316": "Home Direction",
    "1317": "Live Football Minutes Closing",
    "1318": "Live Coupon Waiting Time",
    "1319": "Pre -match ratio (%)",
    "1320": "Live match ratio (%)",
    "1321": "Save",
    "1322": "Default betting limits",
    "1323": "Add staff",
    "1324": "New Password",
    "1325": "Authorities",
    "1326": "Edit balance",
    "1327": "Adding bonus",
    "1328": "Excel",
    "1329": "Edit Personnel",
    "1330": "Edit",
    "1331": "Are you sure?",
    "1332": "Delete",
    "1333": "Process",
    "1334": "IP address",
    "1335": "Target no",
    "1336": "Coupon Creation",
    "1337": "Deposit Money",
    "1338": "Withdraw",
    "1339": "Change password",
    "1340": "Register",
    "1341": "Login",
    "1342": "Deletion",
    "1343": "Dealer editing",
    "1344": "Dealer",
    "1345": "Adding bonus",
    "1346": "Manual Money Uploading",
    "1347": "Customer Deletion",
    "1348": "Customer editing",
    "1349": "Adding customer",
    "1350": "Coupon conclusion",
    "1351": "Deposit cancellation",
    "1352": "Deposit confirmation",
    "1353": "Login",
    "1354": "Exit",
    "1355": "Manual withdrawal",
    "1356": "Settings update",
    "1357": "Withdrawal Cancellation",
    "1358": "Withdrawal confirmation",
    "1359": "Add account details",
    "1360": "Explanation",
    "1361": "Edit IP Address",
    "1362": "There were no results!",
    "1363": "Add the payment method",
    "1364": "Method",
    "1365": "Yes",
    "1366": "No",
    "1367": "Visual address",
    "1368": "Processing fee",
    "1369": "Processing time",
    "1370": "Minimum deposit",
    "1371": "Maximum deposit",
    "1372": "Minimum withdraw",
    "1373": "Maximum withdraw",
    "1374": "Order",
    "1375": "Edit the Payment Method",
    "1376": "Request",
    "1377": "Poker",
    "1378": "Bingo",
    "1379": "Minimum ratio",
    "1380": "Should it be installed automatically to new members?",
    "1381": "Edit Bonus",
    "1382": "If it will be installed automatically",
    "1383": "Deposit",
    "1384": "Country",
    "1385": "Withdraw",
    "1386": "Number",
    "1387": "Add Announcement",
    "1388": "Language",
    "1389": "Announcement",
    "1390": "Edit Announcement",
    "1391": "Add Page",
    "1392": "Page",
    "1393": "Edit Page",
    "1394": "Add promotions",
    "1395": "Promotion",
    "1396": "Edit promotional",
    "1397": "Add Slider",
    "1398": "Slider",
    "1399": "Slider Edit",
    "1400": "Link address",
    "1401": "Residential",
    "1402": "Homepage",
    "1403": "Sports page",
    "1404": "Casino page",
    "1405": "Slot page",
    "1406": "Bingo Page",
    "1407": "Poker page",
    "1408": "Promotional page",
    "1409": "CSS",
    "1410": "JS",
    "1411": "Template Edit",
    "1412": "Html code",
    "1413": "Customer note",
    "1414": "Add the Dealer",
    "1415": "Total balance",
    "1416": "Edit the Dealer",
    "1417": "Bill",
    "1418": "Rake",
    "1419": "Bingo detail",
    "1420": "Betting numbers",
    "1421": "Winning Numbers",
    "1422": "Card number",
    "1423": "Upload Money/Take",
    "1424": "Edit Customer",
    "1425": "Group",
    "1426": "Gender",
    "1427": "Unspecified",
    "1428": "Male",
    "1429": "Woman",
    "1430": "Date of birth",
    "1431": "City",
    "1432": "Address",
    "1433": "Add note",
    "1434": "Update",
    "1435": "Loading",
    "1436": "Withdraw",
    "1437": "Customer Notifications",
    "1438": "Send notification",
    "1439": "Notification",
    "1440": "Provider",
    "1441": "Sport",
    "1442": "League",
    "1443": "Add Limit",
    "1444": "Clean",
    "1445": "Edit Limit",
    "1446": "Add Customer Group",
    "1447": "Customer Group Edit",
    "1448": "Customer groups",
    "1449": "There is multiple IP:",
    "1450": "Live casino",
    "1451": "Active passive",
    "1452": "Support",
    "1453": "Create demand",
    "1454": "Popular league",
    "1455": "Subject",
    "1456": "Message",
    "1457": "Send",
    "1458": "Waiting for an answer",
    "1459": "Answered",
    "1460": "It is closed",
    "1461": "Voice Finance Notification",
    "1462": "Recent financial transactions",
    "1463": "Customer",
    "1464": "Allowed",
    "1465": "Multiple IP",
    "1466": "Risk units",
    "1467": "Color code #",
    "1468": "General",
    "1469": "Football",
    "1470": "Basketball",
    "1471": "Tennis",
    "1472": "Volleyball",
    "1473": "General announcements",
    "1474": "TEAM NAME OR MATCH ID",
    "1475": "New",
    "1476": "System Open/Close",
    "1477": "NEW CUSTOMER REGISTRATION",
    "1478": "Social media",
    "1479": "Dealer Balance Reset",
    "1480": "Dealer members balances have been reset!",
    "1481": "Are you sure the balance of dealer members will delete?",
    "1482": "Image Upload",
    "1483": "Have you read the QR code from the Google Authenticator application?",
    "1484": "Member Registration Address",
    "1485": "<p> What is Google Authenticator? > You can download the Google Authanticator application from your Android or Iphone phones and read the QR code that appears on the panel and confirm. You will be able to login to your phone with the code coming to your phone.",
    "1486": "YouTube",
    "1487": "Customer Limit",
    "1488": "Write a coupon",
    "1489": "Make a Coupon",
    "1490": "Coupon payment",
    "1491": "I accept ratio changes!",
    "1492": "Rates have changed, you need to accept up -to -date rates!",
    "1493": "Your coupon has been successfully saved!",
    "1494": "Tax",
    "1495": "Net",
    "1496": "I received the payment in the amount specified below.",
    "1497": "Signature",
    "1498": "Are you sure for the coupon payment?",
    "1499": "Chassis report",
    "1500": "Coupon paid",
    "1501": "Are you sure for the cancellation of the coupon?",
    "1502": "Your betting coupon is empty. Please choose!",
    "1503": "System",
    "1504": "Coupon amount",
    "1505": "Number of Coupons",
    "1506": "You need to choose the system type!",
    "1507": "Specify the coupon amount!",
    "1508": "Circuit",
    "1509": "Period",
    "1510": "Coupon exchange",
    "1511": "Logo address",
    "1512": "Ikon Address",
    "1513": "Home Background",
    "1514": "Sports Background",
    "1515": "Live background",
    "1516": "Casino Background",
    "1517": "Slot Background",
    "1518": "Virtual background",
    "1519": "Promotion Background",
    "1520": "Coupon exchange commission",
    "1521": "Home Html Code",
    "1522": "Mobile",
    "1523": "Web",
    "1524": "Odds",
    "1525": "Coupon Altml Code",
    "1526": "Active staff",
    "1527": "Cashout History",
    "1528": "Game Detail",
    "1529": "Collective limit",
    "1530": "Compulsory",
    "1531": "Details",
    "1532": "Your bonus request has been sent! The process will result as soon as possible.",
    "1533": "You cannot request again while you have a waiting request!",
    "1534": "Bonus History (Last 5)",
    "1535": "Goldmine",
    "1536": "Wheel",
    "1537": "Other",
    "1539": "Ice Hockey",
    "1540": "Floorball",
    "1541": "Handball",
    "1542": "Bandy",
    "1545": "American Football",
    "1547": "Baseball",
    "1548": "Boxing",
    "1549": "Darts",
    "1550": "Snooker",
    "1551": "Ping pong",
    "1552": "Rugby",
    "1553": "Rugby League",
    "1554": "Curling",
    "1555": "Water ball",
    "1556": "Australian football",
    "1557": "Cricket",
    "1558": "Grass hockey",
    "1559": "Beach volleyball",
    "1560": "Salon football",
    "1561": "Golf",
    "1562": "E-Games",
    "1563": "Speedway",
    "1564": "Chess",
    "1565": "Badminton",
    "1566": "Netball",
    "1567": "Squash",
    "1568": "Sumo",
    "1569": "Politics",
    "1570": "Weather",
    "1571": "Lottery",
    "1574": "Virtual",
    "1575": "Live betting",
    "1576": "Sports & Casino",
    "1577": "Starting date",
    "1578": "End date",
    "1579": "Minimum amount",
    "1580": "Maximum Amount",
    "1581": "Last Login Date Start",
    "1582": "Last Entry Date End",
    "1583": "Registration date finish",
    "1584": "Registration Date Start",
    "1585": "Inadequate balance!",
    "1586": "Finance reports",
    "1587": "Game Reports",
    "1588": "The transaction has been performed!",
    "1589": "Fixed Wage",
    "1590": "Currency",
    "1591": "Sites",
    "1592": "Jackpot",
    "1593": "Page width",
    "1594": "Short registration form",
    "1595": "Automatic routing",
    "1596": "Bonus box",
    "1597": "Popular Live Casino",
    "1598": "Popular slot",
    "1599": "Popular matches",
    "1600": "SOCIAL MEDIA & SEO",
    "1601": "Design & Interface",
    "1602": "Domain names",
    "1603": "Adding Manual Balance",
    "1604": "Manual balance",
    "1605": "Limit",
    "1606": "Affiliate",
    "1607": "Copied",
    "1608": "Under Part",
    "1609": "Customer Delete",
    "1610": "No active bonus!",
    "1612": "Amount regulation",
    "1613": "Your request for withdrawal has been processed. Will be concluded as soon as possible.",
    "1614": "Your deposit request has been processed. Will be concluded as soon as possible.",
    "1615": "Percentage",
    "1616": "HUGH logo",
    "1618": "Security certificate",
    "1619": "Upper menu",
    "1620": "Minimum commission",
    "1621": "Cost",
    "1622": "Aviator",
    "1623": "Tvbet",
    "1624": "Main provider",
    "1625": "Birthday",
    "1626": "New window",
    "1627": "Dimension",
    "1628": "The largest online casino in the Middle East!",
    "1629": "Popular",
    "1630": "History",
    "1631": "Coupon Correction",
    "1632": "Last 1 Month",
    "1633": "List",
    "1634": "Send message",
    "1635": "Automatic withdraw",
    "1636": "Win Excavation",
    "1637": "Live TV",
    "1638": "Completed",
    "1639": "Progressing",
    "1640": "Minimum Time Between Withdraws (Minutes)",
    "1641": "Withdraw amounts 10 and multiples (yes/no)",
    "1642": "Number of times the original deposit must be wagered before withdrawal is allowed (a number)",
    "1643": "Daily maximum bonus limit has been exceeded",
    "1644": "Minimum bonus amount is incorrect",
    "1645": "Maximum bonus amount is incorrect",
    "1646": "The minimum between your shots must be ## minutes!",
    "1647": "Your withdraw must be in the form of 10 and floors!",
    "1648": "After completing the main balance rollover, you can proceed to withdrawal",
    "1649": "Your balance is insufficient!",
    "1650": "Cache",
    "1651": "",
    "1652": "To see the coupon details, you need to go to the Betting History page in the coupon section.",
    "1653": "",
    "1654": "Graphics",
    "1655": "",
    "1656": "Freespin",
    "1657": "Bonus requests",
    "1658": "Since your last financial transaction is a bonus, you cannot request a bonus again.",
    "1659": "You cannot request a bonus while you have a waiting coupon!",
    "1660": "Voice notification repetition",
    "1661": "Use my last withdraw information!",
    "1662": "You cannot request a bonus since you do not have any accounting records in the last 48 hours.",
    "1663": "Welcome",
    "1664": "Attempt",
    "1665": "Loss",
    "1666": "You do not have the right to receive any bonus due to your deposit/withdrawal difference.",
    "1667": "In order to get a lost bonus, you should not have a balance.",
    "1668": "You must have a balance to get an deposit bonus.",
    "1669": "Promotional code",
    "1670": "(not required)",
    "1671": "Automatic bonus",
    "1672": "Deposit/withdraw profit damage control in the last 24 hours",
    "1673": "Last transaction bonus control",
    "1674": "Last 48 hours accounting record control",
    "1675": "Amount type",
    "1676": "Open Coupon Control",
    "1677": "You do not have the right to bonus",
    "1678": "You need to get your deposit bonus immediately after investing!",
    "1679": "Provider search ...",
    "1680": "Game search ...",
    "1681": "Changing percentage",
    "1682": "In order to get a lost bonus, you must have finished your balance completely",
    "1683": "Monthly",
    "1684": "Automatic bonus is closed for those who have withdrawn in the last 48 hours.",
    "1685": "Create a coupon",
    "1686": "The event is over or bets were paused!",
    "1687": "Posted by Posts",
    "1688": "Category",
    "1689": "Collective message",
    "1690": "Tournaments",
    "1691": "Multiplier",
    "1692": "Turnover",
    "1693": "Tournament",
    "1694": "The remaining time for the end of the tournament:",
    "1695": "day",
    "1696": "hour",
    "1697": "min",
    "1698": "sec",
    "1699": "Total prize",
    "1700": "The tournament ends",
    "1701": "Refresh the table",
    "1702": "Games in Tournament",
    "1703": "Tournament Notes",
    "1704": "Rules and Conditions",
    "1705": "Tournament Background",
    "1706": "then starts ...",
    "1707": "Upper message",
    "1708": "Spin",
    "1709": "Bonus Request",
    "1710": "Deposit",
    "1711": "Contact us",
    "1712": "Very soon...",
    "1713": "Send friend",
    "1714": "User not found!",
    "1715": "Your balance is insufficient!",
    "1716": "You can transfer after making the main money cycle!",
    "1717": "Your request has been sent to his friend!",
    "1718": "Lower menu",
    "1719": "Your request has been made!",
    "1720": "With the Send to your friend, you can transfer your balance to a user you want in the site.",
    "1721": "Snow effect",
    "1722": "Personnel Notes",
    "1723": "Yearly",
    "1724": "Security",
    "1725": "SOLIDTV",
    "1726": "Translate",
    "1728": "You cannot get this bonus since your latest deposit method does not comply with the deposit requirement of the bonus.",
    "1729": "History",
    "1730": "Change the user name",
    "1731": "Time period",
    "1732": "Positive",
    "1733": "Negative",
    "1734": "Could not be reached",
    "1735": "Performance",
    "1736": "Daily maximum withdrawal",
    "1737": "##sitename## TV",
    "1738": "Quick Answers",
    "1739": "Abbreviation",
    "1740": "The new address of the bet!",
    "1741": "Executive",
    "1742": "Reporting",
    "1743": "Sports betting",
    "1744": "Live bets",
    "1745": "Slots",
    "1746": "Virtual sports",
    "1747": "Races",
    "1748": "Add Withdrawal",
    "1749": "With the bonus you receive, you cannot shoot on the maximum earning limit.",
    "1750": "Maximum earnings (floor)",
    "1751": "Commission",
    "1752": "Total Withdraw",
    "1753": "Average bonus",
    "1754": "Average member profit",
    "1755": "Average Member Deposit",
    "1756": "Average number of coupons",
    "1757": "Average number of casino hands",
    "1758": "Average Slot Hands Number",
    "1759": "Low risk",
    "1760": "Medium risk",
    "1761": "High risk",
    "1762": "Maximum casino multiplier",
    "1763": "Maximum slot multiplier",
    "1764": "Reset the balance of those who have not entered for 2 months",
    "1765": "Maximum earnings (Deposit floor)",
    "1766": "Mail Templates",
    "1767": "Birthday Bonus",
    "1768": "Number of times the bonus amount must be wagered before withdrawal is allowed (a number)\t",
    "1769": "After completing the bonus cycle, you can withdrawal!",
    "1770": "Return bonus",
    "1771": "Turkey's Only Official Casino Site",
    "1772": "Where did you hear us?",
    "1773": "Search engines",
    "1774": "Social media",
    "1775": "Friend recommendation",
    "1776": "Other",
    "1777": "ULTİ TV",
    "1778": "Ulti lottery",
    "1779": "Ulti wheel",
    "1780": "Where did it come from",
    "1781": "You have reached the daily maximum withdrawal limit! You can request withdrawal again on the new day.",
    "1782": "You have reached the maximum earning limit! You cant shoot any more!",
    "1783": "You have reached the maximum deposit earning limit! You cant shoot any more!",
    "1784": "Send an email",
    "1785": "Spaceman",
    "1786": "Turbo Games",
    "1787": "Subtotal",
    "1788": "Monday",
    "1789": "Tuesday",
    "1790": "Wednesday",
    "1791": "Thursday",
    "1792": "Friday",
    "1793": "Saturday",
    "1794": "Sunday",
    "1795": "Special value",
    "1796": "Security word",
    "1797": "To understand that you are on the right site, then determine your security word to be shown later.",
    "1798": "Your security word has been successfully recorded.",
    "1799": "Change Name Surname",
    "1800": "Graphic",
    "1801": "",
    "1802": "##sitename## TV",
    "1804": "You can only get the bonus on the relevant day of the week.",
    "1805": "You can't get a bet bonus!",
    "1806": "You cant get a casino bonus!",
    "1807": "Last transaction requirement",
    "1808": "Your Identity Number is invalid! You must have your information confirmation through live support.",
    "1810": "Mega",
    "1811": "Major",
    "1812": "Minor",
    "1813": "Mini",
    "1814": "Last Winner",
    "1815": "Time",
    "1816": "Temporarily Deactivate Account",
    "1817": "To temporarily freeze your account, enter your password in the field below and press the submit button",
    "1818": "24 hours",
    "1819": "1 week",
    "1820": "1 months",
    "1821": "3 months",
    "1822": "Changing Accounting Status",
    "1823": "What is Google Authenticator?",
    "1824": "Google Authenticator is activated. After activating it, you will have to automatically log out of the site and log in with Google Authenticator. Are you sure?",
    "1825": "Transaction successful",
    "1826": "Quantity",
    "1827": "Google Authenticator (Personnel)",
    "1828": "Google Authenticator (Membership)",
    "1829": "It is a security application that allows you to enter the code you created on your phone along with your username and password when logging in.",
    "1830": "How to do it?",
    "1831": "All you have to do is download the Google Authanticator application from your Android or iPhone, scan the QR code that appears on the panel and confirm. You will be able to log in with the code you created on your phone for all subsequent logins.",
    "1832": "2-step verification",
    "1833": "Do you want to cancel Google Authenticator?",
    "1834": "Click to confirm",
    "1835": "Activate Google Authenticator",
    "1836": "Incorrect Entries",
    "1837": "VIP Club",
    "1838": "Affiliate",
    "1839": "Help center",
    "1840": "Dark",
    "1841": "Light",
    "1842": "Menu",
    "1843": "Lobby",
    "1844": "Conference League UEFA",
    "1845": "NBA",
    "1846": "Buy Crypto",
    "1847": "Connect",
    "1848": "Most Popular FAQs",
    "1849": "Account",
    "1850": "Verification",
    "1851": "Play Demo",
    "1852": "Real Play",
    "1853": "",
    "1854": "Do you need help?",
    "1855": "",
    "1856": "",
    "1857": "Baccarat",
    "1858": "Blackjack",
    "1859": "Table games",
    "1860": "Roulette",
    "1861": "Similar Games",
    "1862": "",
    "1863": "User",
    "1864": "Time left until the tournament starts:",
    "1865": "Are you a registered user of ours? ##logintext## by clicking here",
    "1866": "Login",
    "1867": "",
    "1868": "",
    "1869": "REFERRAL LINK",
    "1870": "",
    "1871": "",
    "1872": "",
    "1873": "Funds",
    "1874": "Users",
    "1875": "Campaigns",
    "1876": "Sort by",
    "1877": "Campaign Hits",
    "1878": "Unique Deposits",
    "1879": "Create New Campaign",
    "1880": "Last Deposits",
    "1881": "Wagered",
    "1882": "Available Commission",
    "1883": "Total Commission",
    "1884": "",
    "1886": "",
    "1887": "",
    "1888": "",
    "1889": "Your VIP Progress",
    "1890": "Progress",
    "1891": "Level System",
    "1892": "Bronze",
    "1893": "Silver",
    "1894": "Gold",
    "1895": "Platinium",
    "1896": "Diamond",
    "1897": "",
    "1898": "",
    "1899": "",
    "1900": "",
    "1901": "",
    "1902": "You must log in to get the link address",
    "1903": "We're sorry, access to this online casino site is restricted from your country due to legal constraints. Due to this restriction, you are unable to play casino games from your current location.",
    "1904": "If you have any questions, feel free to email!",
    "1905": "",
    "1906": "",
    "1907": "6 months",
    "1908": "1 year",
    "1909": "5 years",
    "1910": "Indefinite",
    "1911": "Last 48 hours deposit/withdrawal profit and loss control",
    "1912": "Right to request once in 24 hours",
    "1913": "Games Background",
    "1914": "Tournament",
    "1915": "The world's largest online crypto casino!",
    "1916": "Maximum Number of Members",
    "1917": "The table of the member who wins the tournament is updated.",
    "1918": "Hide my username in winners sections",
    "1919": "Get Bonus",
    "1920": "Wheel Image (720x720)",
    "1921": "Cursor Image (328x184) - Margins (Top/Bottom 10px - Right 30px)",
    "1922": "Button Image (242x124)",
    "1923": "Area Text",
    "1924": "Area Value",
    "1925": "Otomatik Bakiye",
    "1926": "Günde 1 Kere",
    "1927": "Her yatırımda 1 Kere",
    "1928": "Spin Çevir Bonus",
    "1929": "Sınır",
    "1930": "SEO",
    "1931": "Description",
    "1932": "Url",
    "1933": "Title",
    "1934": "View in other languages",
    "1935": "Page Not Found",
    "1936": "Group Number",
    "1937": "Email Verification Code",
    "1938": " Send Code",
    "1939": "Sent",
    "1940": "Turnover",
    "1941": "Verification code for withdrawal",
    "1942": "Use the following verification code to make a withdrawal",
    "1943": "Verification Code",
    "1944": "You have entered an incorrect verification code!",
    "1945": "Password change request",
    "1946": "Your password change request has been received.",
    "1947": "You can change your password by clicking on the link below!",
    "1948": "Best of luck!",
    "1949": "Register for the affiliate program",
    "1950": "Campaign Name",
    "1951": "dd.mm.yyyy",
    "1952": "Customers (Affiliate)",
    "1953": "Affiliates",
    "1954": "Show More",
    "1955": "Show Less",
    "1956": "Skype",
    "1957": "Telegram",
    "1958": "Communication",
    "1959": "en",
    "1960": "File Upload",
    "1961": "File upload area text",
    "1962": "Uploaded files",
    "1963": "File",
    "1964": "No",
    "1965": "Google Tag Manager Id (GTM-000000)",
    "1967": "Edit \tE-mail address",
    "1968": "Edit Phone",
    "1969": "Copy",
    "1970": "Enter code to activate",
    "1971": "Withdraw Priority",
    "1972": "Risky transaction",
    "1973": "Withdraw Addresses",
    "1974": "Levant Special",
    "1975": "High Flyer",
    "1976": "Profitability",
    "1977": "Weekly Bonus",
    "1978": "Lost Bonus",
    "1979": "Commission Return",
    "1980": "Monthly Bonus",
    "1981": "The Rewards",
    "1982": " New rewards at every level",
    "1983": "Wager Amount",
    "1984": "",
    "1985": "Verification",
    "1986": "Send Verification Code",
    "1987": "Request Code",
    "1988": " Verification code will be sent to your phone number. Check your number and press the request code button.",
    "1989": "Once",
    "1990": "Repetition",
    "1991": "Special",
    "1992": "All Games",
    "1993": "Change Status",
    "1994": "Weekly",
    "1995": "Weak",
    "1996": "Poor",
    "1997": "Medium",
    "1998": "Strong",
    "1999": "You must update your password every 3 months for any changes you may have.",
    "2000": "Your new password should be different from your old one",
    "2001": "This site is protected by reCAPTCHA and the Google <a href=\"https://policies.google.com/privacy\" target='_blank'>Privacy Policy</a> and <a href=\"https://policies.google.com/terms\" target='_blank'>Terms of Service</a> apply.",
    "2002": "Your password should be different from your username!",
    "2003": "Please verify you are human",
    "2004": "Invalid verification code",
    "2005": "Keys",
    "2006": "Invalid Google Authenticator code",
    "2007": "Total Bonuses Amount",
    "2008": "Available balance of all accounts",
    "2009": "Gross Profit",
    "2010": "Net profit",
    "2011": "GGR (Gross Gaming Revenue)",
    "2012": "NGR (Net Gaming Revenue)",
    "2013": "NRCs (New Registered Customers)",
    "2014": "Deposits Count",
    "2015": "UDC (Unique Depositors Count)",
    "2016": "NDC (New depositing Customer) Count",
    "2017": "FTD (First time Depositors) Count",
    "2018": "FTD Amount Average",
    "2019": "ARPPU (Average Revenue Per Paying User)",
    "2020": "Active Customers (Last 3 Months)",
    "2021": "Inactive Customers (Last 3 Months)",
    "2022": "Customer Churn Rate",
    "2023": "First Time Depositors",
    "2024": "New depositing customers",
    "2025": "Depositors",
    "2026": "Allowed Providers",
    "2027": "Send Bulk Mail",
    "2028": "Customer List",
    "2029": "Look at the phone",
    "2030": "Look at the Email",
    "2031": "Look at the Identity No",
    "2032": "Customer payment update",
    "2033": "Customer withdraw address clear",
    "2034": "Customer Add",
    "2035": "Customer bonus status update",
    "2036": "Customer access update",
    "2037": "Customer password change",
    "2038": "Customer payment methods change",
    "2039": "Look at the transactions",
    "2040": "Look at the customer",
    "2041": "Delivery",
    "2042": "Payments",
    "2043": "Salary",
    "2044": "Marketing",
    "2045": "Technic",
    "2046": "You can receive your verification code via phone and email by using one of your Email, Username, or Phone details, and then create your new password.",
    "2047": "Enter the verification code you received via email and phone to create your new password.",
    "2048": "##logintext## with your new passwod",
    "2049": "Game Code",
    "2050": "Desktop",
    "2051": "Add Bonus in Bulk",
    "2052": "Username (One per line)",
    "2053": "The following customers could not be awarded a bonus!",
    "2054": "Staff Name",
    "2055": "",
    "2056": "download for your android device",
    "2057": "download for your iOS device",
    "2058": "You can always access our current address by typing ##domain##.",
    "2059": "Follow Us!",
    "2060": "Advertising and Affiliate Agreements",
    "2061": "Support and Help",
    "2062": "Requests and Suggestions",
    "2063": "",
    "2064": "",
    "2065": "Credit Card",
    "2066": "##sitename## © ##year## - All Rights Reserved.",
    "2067": "Featured Games",
    "2068": "Discover popular slot and casino games.",
    "2069": "Games could not be loaded",
    "2070": "Game URL could not be retrieved",
    "2071": "Game could not be launched",
    "2072": "All Providers",
    "2073": "Clear the filters and try again.",
    "2074": "Live Casino Thrill",
    "2075": "Start winning with real dealers!",
    "2076": "Logging in...",
    "2077": "Promotions could not be loaded",
    "2078": "There are no active promotions right now.",
    "2079": "New campaigns will appear here when added.",
    "2080": "Go to Bonuses",
    "2081": "Review our selected campaigns, see the terms, and don't miss bonus opportunities.",
    "2082": "No Image",
    "2083": "View promotion ##title##",
    "2084": "Please log in",
    "2085": "User ID not found",
    "2086": "Sportsbook could not be started",
    "2087": "Sportsbook could not be loaded",
    "2088": "Sportsbook provider credentials are not configured.",
    "2089": "Sportsbook provider client could not be loaded",
    "2090": "Bootstrapper not found",
    "2091": "Error",
    "2092": "Try Again",
    "2093": "Loading sportsbook...",
    "2094": "Image Failed to Load",
    "2095": "Just now",
    "2096": "Popular Slots",
    "2097": "",
    "2098": "",
    "2099": "",
    "2100": "",
    "2101": "",
    "2102": "",
    "2103": "",
    "2104": "",
    "2105": "",
    "2106": "",
    "2107": "Login failed",
    "2108": "Don't have an account?",
    "2109": "Sponsorship",
    "2110": "General Rules",
    "2111": "Responsible Gaming",
    "2112": "Popular Casino Games",
    "2113": "Table",
    "2114": "No games found.",
    "2115": "Provider selection",
    "2116": "Clear Filters",
    "2117": "You must log in for sportsbook",
    "2118": "Play",
    "2119": "VIP levels cannot be displayed right now.",
    "2120": "Welcome to our world full of privileges.",
    "2121": "Your Current Level",
    "2122": "You need to log in to see VIP privileges.",
    "2123": "Privileges",
    "2124": "",
    "2125": "",
    "2126": "",
    "2127": "",
    "2128": "",
    "2129": "",
    "2130": "",
    "2131": "",
    "2132": "An error occurred",
    "2133": "",
    "2134": "",
    "2135": "Grand Jackpot",
    "2136": "ID",
    "2137": "Application failed to load",
    "2138": "Language",
    "2139": "Turkish",
    "2140": "English",
    "2141": "I confirm freezing my account.",
    "2142": "Your net loss is below the minimum required for this bonus.",
    "2143": "You have already used your daily bonus today.",
    "2144": "The trial bonus is only for users who have not used a bonus before.",
    "2145": "The trial bonus is only for users with zero transactions.",
    "2146": "Your transaction history could not be found, so you do not meet this rule.",
    "2147": "You cannot claim this bonus because your last 24 hours are in profit.",
    "2148": "You cannot claim this bonus because your last 48 hours are in profit.",
    "2149": "You already have an active bonus.",
    "2150": "Bonus not found or inactive.",
    "2151": "This bonus requires manual approval.",
    "2152": "Bonus ID must be numeric.",
    "2153": "Bonus box has not been opened.",
    "2154": "Your last transaction must be ##types##.",
    "2155": "User not found (ID: ##id##).",
    "2156": "User ID could not be verified. (ID: ##id##)",
    "2157": "Invalid user ID.",
    "2158": "User account is not active.",
    "2159": "You need to log in.",
    "2160": "Invalid site ID.",
    "2161": "Multiple accounts detected on the same IP address.",
    "2162": "Welcome bonus can only be used on the first deposit.",
    "2163": "Remaining bonus rollover",
    "2164": "Remaining deposit rollover",
    "2167": "Bonus could not be granted due to too many transactions in a short time.",
    "2168": "Bonus could not be granted due to too many IP addresses used in the last 7 days.",
    "2169": "Bonus could not be granted because the bonus usage limit was exceeded.",
    "2170": "Bonus could not be granted due to security checks.",
    "2171": "You have reached the highest level!",
    "2172": "You need ##xp## XP more to reach ##tier## level.",

    "2200": "Session information is missing. Please log in.",
    "2201": "Your session has expired. Please log in again.",
    "2202": "Invalid session information.",
    "2203": "Authorization error.",
    "2204": "Invalid username or password.",
    "2205": "You do not have access to this site.",
    "2206": "You do not have permission for this action.",
    "2207": "Invalid input. Please check and try again.",
    "2208": "This record already exists.",
    "2209": "The record you are looking for was not found.",
    "2210": "Too many requests. Please wait a moment and try again.",
    "2211": "Signature verification failed.",
    "2212": "Request timed out. Please try again.",
    "2213": "An unexpected error occurred. Please try again later.",
    "2214": "Site ID is required.",
    "2215": "Live connection authorization failed. Please log in again.",
    "2216": "Live connection could not be established. It will retry in the background.",
    "2217": "Live connection retry attempts are exhausted. Please refresh the page.",
    "2218": "Page failed to load. Please refresh and try again.",
    "2220": "Your message has been received. We will get back to you shortly.",
    "2221": "Account has been frozen.",
    "2222": "Partner visuals could not be found.",
    "2223": "Phone / Email / Telegram / Skype",
    "2224": "You have no notifications yet.",
    "2225": "",
    "2226": "",
    "2227": "",
    "2228": "",
    "2229": "",
    "2230": "",
    "2231": "",
    "2232": "",
    "2233": "",
    "2234": "",
    "2235": "",
    "2236": "",
    "2237": "",
    "2238": "",
    "2239": "",
    "2240": "",
    "2241": "",
    "2242": "",
    "2243": "Welcome to the VIP Club",
    "2244": "",
    "2245": "",
    "2246": "Tiers and Rewards",
    "2247": "Daily Max Withdraw",
    "2248": "User cancelled via Bonus Center",
    "2249": "Skip to main content",
    "2250": "New Games",
    "2251": "Editor's Picks",
    "2252": "",
    "2253": "",
    "2254": "See All",
    "2261": "Settings",
    "2262": "Platform",
    "2263": "About Us",
    "2264": "Currency",
    "2265": "Language",
    "2266": "Contact",
    "2267": "Support",
    "2268": "Affiliate",
    "2269": "General",
    "2270": "No contact details configured.",
    "2271": "Loyalty Program",
    "2272": "FAQ",
    "2273": "AML Policy",
    "2274": "Responsible Gaming",
    "2275": "Privacy Policy",
    "2276": "Terms of Use",
    "2277": "Sports Policy",
    "2278": "Domain",
    "2279": "Help Center",
    "2280": "",
    "2281": "",
    "2282": "Contact support at:",
    "2283": "",
    "2284": "Supported payment coins",
    "2285": "Partner list could not be loaded.",
    "2286": "",
    "2287": "Soccer",
    "2288": "Counter-Strike",
    "2289": "Ice Hockey",
    "2290": "Tennis",
    "2291": "Basketball",
    "2292": "Cycling",
    "2293": "Football",
    "2294": "Handball",
    "2295": "Boxing",
    "2296": "Cricket",
    "2297": "Baseball",
    "2298": "League of Legends",
    "2299": "Sportsbook",
    "2300": "Providers",
    "2301": "VIP",
    "2302": "Save this as a quick withdrawal address",
    "2303": "Saved addresses",
    "2304": "Lucky Wheel",
    "2305": "Tap to spin",
    "2306": "Data unavailable",
    "2307": "Date",
    "2308": "ID",
    "2309": "Winner",
    "2310": "Amount",
    "2311": "No winners yet",
    "2312": "Total Winnings",
    "2313": "Total Winners",
    "2400": "Help Center",
    "2401": "Find answers to frequently asked questions.",
    "2402": "No categories yet",
    "2403": "views",
    "2404": "found helpful",
    "2405": "Featured articles",
    "2406": "All categories",
    "2407": "No articles in this category yet",
    "2408": "Search results",
    "2409": "results found",
    "2410": "No articles match your search",
    "2411": "Article not found",
    "2412": "Was this article helpful?",
    "2413": "Thanks for your feedback!",
    "2414": "We received your feedback and will improve.",
    "2415": "Yes",
    "2416": "No",
    "2417": "Talk to support",
    "2418": "Search articles...",
    "2419": "No VIP levels have been configured yet.",
    "2420": "No homepage content has been configured yet.",
    "2421": "Connection Unavailable",
    "2422": "Your session could not be verified. Please try again.",
    "2423": "Site settings could not be loaded. Please try again.",
    "2424": "This site could not be verified for this address. Please try again.",
    "2425": "Tasks could not be loaded. Please try again.",
    "2426": "The reward could not be claimed. Please try again.",
    "2427": "Verify",
    "2428": "Go Back",
    "2429": "Enter the 6-digit verification code from your authenticator app.",
    "2430": "2FA Code",
    "2431": "Please complete the security check.",
    "2432": "Account",
    "2433": "Finance",
    "2434": "Activity",
    "2435": "VIP tiers and rewards",
    "2436": "Homepage layout is loading",
    "2437": "Featured help content could not be loaded.",
    "2438": "Close notification",
    "2439": "Spin credit",
    "2440": "Complete your task and earn your spin",
    "2441": "Tasks",
    "2442": "Deposit requirements",
    "2443": "Progresses separately from tasks.",
    "2444": "Required deposit count",
    "2445": "Total deposit",
    "2446": "The general deposit requirements for this period are complete.",
    "2447": "Enter your code to unlock your bonus",
    "2448": "Promo code",
    "2449": "Spinning...",
    "2450": "Open Wild Market",
    "2451": "Exchange Wild Rewards",
    "2452": "Balance",
    "2453": "Tournaments",
    "2454": "Browse active and upcoming tournaments and take your place in the prize pool.",
    "2455": "There are no tournaments to display right now.",
    "2456": "Turnover",
    "2457": "Multiplier",
    "2458": "Provider",
    "2459": "Active",
    "2460": "Upcoming",
    "2461": "Finished",
    "2462": "Prize Pool",
    "2463": "Starts",
    "2464": "Ends",
    "2465": "Details",
    "2466": "Tournament",
    "2467": "Back",
    "2468": "Tournament not found",
    "2469": "The tournament you are looking for may have been removed or ended.",
    "2470": "Leaderboard",
    "2471": "No participants yet.",
    "2472": "Tournament Games",
    "2473": "Refresh",
    "2474": "Rank",
    "2475": "User",
    "2476": "Score",
    "2477": "Earnings",
    "2478": "Custom",
    "2479": "Sport",
    "2480": "Casino",
    "2481": "Slot",
    "2482": "All Games",
    "2483": "##sitename## Originals",
    "2484": "Bonus Buy",
    "2485": "Card",
    "2486": "Sports",
    "2487": "Show password",
    "2488": "Hide password",
    "2489": "Please enter the 6-digit verification code.",
    "2490": "You must accept the terms and conditions.",
    "2491": "Please enter a valid phone number.",
    "2492": "Please start the registration again.",
    "2493": "Please enter the verification code.",
    "2494": "Verification Code",
    "2495": "Verify and Register",
    "2496": "Resend Code",
    "2497": "Select telephone country code",
    "2498": "Select date of birth",
    "2499": "The account is temporarily locked. Please try again later.",
    "2500": "The verification code is invalid.",
    "2501": "The verification code is invalid or has expired.",
    "2502": "The setup session has ended. Please start again.",
    "2503": "2FA is already active.",
    "2504": "2FA is not active.",
    "2505": "2FA is required for this account. Contact the panel administrator to disable it.",
    "2506": "This username is already in use.",
    "2507": "This email is already in use.",
    "2508": "This phone number is already registered.",
    "2509": "A valid phone number is required.",
    "2510": "Acceptance of the general terms and privacy notice is required.",
    "2511": "The verification session is invalid.",
    "2512": "The verification session is invalid or has expired.",
    "2513": "Too many SMS messages were sent to this phone number. Please try again later.",
    "2514": "We sent a verification code to ##phone##. Enter it below to complete registration.",
    "2515": "Resend in ##seconds##s",
    "2516": "##sitename## Rewards",
    "2517": "Reward Center",
    "2518": "Complete your daily tasks, earn a spin and turn the prize wheel safely.",
    "2519": "Redeeming...",
    "2520": "Use code",
    "2521": "Spin the wheel",
    "2522": "The wheel cannot be spun",
    "2523": "Click the wheel",
    "2524": "Earn a spin first",
    "2525": "Wild information is loading",
    "2526": "Wild information is currently unavailable",
    "2527": "Open Wild Market — ##reward## is ready",
    "2528": "Open Wild Market — ##balance##/##target## Wild (##reward##)",
    "2529": "Exchange the Wild tokens you collect from the wheel for rewards here.",
    "2530": "There are no rewards available to exchange right now. Keep collecting Wild.",
    "2531": "Physical reward",
    "2532": "##stock## in stock",
    "2533": "Exchanging...",
    "2534": "Not enough Wild",
    "2535": "Out of stock",
    "2536": "Exchange",
    "2537": "Wallet",
    "2538": "Alerts",
    "2539": "Account hub",
    "2540": "Your team",
    "2541": "Select your team",
    "2542": "Select a team",
    "2543": "Available Bonuses",
    "2544": "Quick access",
    "2545": "Setup Key",
    "2546": "Active Devices and Sessions",
    "2547": "View the devices signed in to your account and close them individually.",
    "2548": "Sessions are loading...",
    "2549": "No active sessions were found.",
    "2550": "This device",
    "2551": "No active tasks right now.",
    "2552": "Payment methods are currently unavailable.",
    "2553": "Withdrawal eligibility cannot be verified right now.",
    "2554": "Withdrawal eligibility is being verified...",
    "2555": "The QR code could not be created. Use the key manually.",
    "2556": "The setup key was copied.",
    "2557": "The setup key could not be copied.",
    "2558": "2FA was enabled successfully.",
    "2559": "Enter your current password.",
    "2560": "2FA was disabled.",
    "2561": "The session was closed.",
    "2562": "Additional login verification with an authenticator app.",
    "2563": "A 6-digit verification code will now be required when signing in.",
    "2564": "Current Password",
    "2565": "Your current password",
    "2566": "Processing...",
    "2567": "Disable 2FA",
    "2568": "Add the key below to your authenticator app, then verify the 6-digit code from the app.",
    "2569": "2FA QR code",
    "2570": "Copy Key",
    "2571": "6-Digit Code",
    "2572": "This setup session is valid until ##time##.",
    "2573": "Verifying...",
    "2574": "Enable 2FA",
    "2575": "Cancel",
    "2576": "Add an extra verification code when signing in. This makes account access much harder even if your password is compromised.",
    "2577": "Preparing...",
    "2578": "Start 2FA Setup",
    "2579": "Unknown device",
    "2580": "Browser information unavailable",
    "2581": "Last used",
    "2582": "Closing...",
    "2583": "Close This Session",
    "2584": "Close Session",
    "2585": "My Free Spins",
    "2586": "Rewards available in Hub88 games.",
    "2587": "Free Spins are refreshing",
    "2588": "Your Free Spins are loading...",
    "2589": "Free Spin information is currently unavailable.",
    "2590": "Available bonuses are currently unavailable.",
    "2591": "You do not have any Hub88 Free Spin rewards yet.",
    "2592": "Status pending",
    "2593": "Bet value",
    "2594": "Bet count",
    "2595": "Play Game",
    "2596": "Opening game...",
    "2597": "The reward game cannot be opened right now. Please try again.",
    "2598": "Previous",
    "2599": "Pending",
    "2600": "Cancelled",
    "2601": "Failed",
    "2602": "Expired",
    "2603": "Deposit count",
    "2604": "Deposit amount",
    "2605": "Login streak (days)",
    "2606": "Logins in the period",
    "2607": "Game rounds",
    "2608": "Claimed",
    "2609": "Claim Reward",
    "2610": "Waiting",
    "2611": "The reward was credited to your account",
    "2612": "The reward was claimed",
    "2613": "You currently have ##credits## available spin credits.",
    "2614": "You can spin the wheel now.",
    "2615": "Reward: ##amount## spin",
    "2616": "Valid for ##days## days",
    "2617": "Status",
    "2618": "Retrying...",
    "2619": "Wagering is still in progress",
    "2620": "Total remaining wagering: ##amount##.",
    "2621": "Bonus: ##amount##",
    "2622": "Principal: ##amount##",
    "2623": "Mobile navigation",
    "2624": "Primary navigation",
    "2625": "Utility navigation",
    "2626": "Secondary navigation",
    "2627": "Quick actions",
    "2628": "Engagement",
    "2629": "Social media",
    "2630": "Open menu",
    "2631": "Close navigation",
    "2632": "Close more navigation",
    "2633": "Other navigation",
    "2634": "Quick navigation",
    "2635": "Close modal backdrop",
    "2636": "Close modal",
    "2637": "Loading",
    "2638": "Operator Information",
    "2639": "##site## is owned and operated by ##legalName##. Registered address: ##address##. Contact:",
    "2640": "Wild reward exchanged",
    "2641": "The code was redeemed successfully",
    "2642": "Physical reward:",
    "2643": "Won:",
    "2644": "Result:",
    "2645": "Security verification is not configured.",
    "2646": "Similar games are currently unavailable.",
    "2647": "No similar games found.",
    "2648": "Recommendations are currently unavailable.",
    "2649": "The BETBY customer interface is not enabled yet. This screen will open after the official web client and allowed domains have been configured.",
    "2650": "This selection can only be made once.",
    "2651": "Saving...",
    "2652": "Save Team",
    "2653": "Anjouan licence information",
    "2654": "Licence number",
    "2655": "Licence type",
    "2656": "Approved domain",
    "2657": "Company registration number",
    "2658": "Registered address",
    "2659": "Categories could not be loaded.",
    "2660": "The spin wheel campaign is not active.",
    "2661": "No active spin wheel segment was found.",
    "2662": "You have no available spin credits.",
    "2663": "Invalid promo code.",
    "2664": "You have already used this promo code.",
    "2665": "The Wild reward was not found or is inactive.",
    "2666": "This Wild reward is out of stock.",
    "2667": "Your Wild balance is insufficient.",
    "2668": "Please select a team.",
    "2669": "Your team selection has been saved.",
    "2670": "Withdrawal eligibility cannot be verified right now. Please try again.",
    "2671": "You cannot submit a withdrawal request until the wagering requirements are completed.",
    "2672": "Your bonus request has been received. You will be notified when it is approved.",
    "2673": "Reset your password",
    "2674": "Enter the email address linked to your account. If an eligible account exists, we will send a reset link.",
    "2675": "Email address",
    "2676": "Send reset link",
    "2677": "If an eligible account matches this email address, a password reset link has been sent.",
    "2678": "New password",
    "2679": "Confirm new password",
    "2680": "Reset password",
    "2681": "Your password has been changed. You can now sign in with your new password.",
    "2682": "This reset link is invalid or has expired. Request a new link.",
    "2683": "We could not complete this request right now. Please try again later.",
    "2684": "Back to sign in",
    "2685": "Use 8-256 characters. Uppercase letters, lowercase letters, numbers and symbols are optional.",
    "2686": "Details",
    "2687": "Get Bonus",
    "2688": "Live Betting",
    "2689": "Create an account",
    "2690": "Enter your details to create your account.",
    "2691": "Already have an account?",
    "2692": "Deposit method",
    "2693": "Payment page",
    "2694": "Bank transfer details",
    "2695": "Enter your deposit amount on the payment provider's page. Your balance updates once payment is confirmed.",
    "2696": "Open payment page",
    "2697": "Use these bank details for your transfer. Your balance updates once the transfer is confirmed.",
    "2698": "Bank transfers require a whole TRY amount.",
    "2699": "This deposit method is currently unavailable.",
    "2700": "Account holder",
    "2701": "Reference",
    "2702": "Payment status is being confirmed. Use Open payment page to check the same payment again.",
    "2703": "This account has an unresolved VIPPay deposit request. Wait for the existing payment to be resolved before making a new deposit.",
    "2704": "Enter a valid Turkish IBAN.",
    "2705": "No eligible approved deposit was found for this bonus.",
    "2706": "You have reached the usage limit for this bonus.",
    "2707": "Your deposit is outside the eligible sequence for the welcome bonus.",
    "2708": "You have already used the welcome bonus for this deposit.",
    "2709": "This deposit has already been used for a bonus.",
    "2710": "Identity verification is required to request a bonus.",
    "2711": "This bonus is only available on certain days.",
    "2712": "This bonus is only available during certain hours.",
    "2713": "Your bonus request is being processed. Please wait.",
    "2714": "You do not meet the requirements for this bonus.",
    "2715": "Your bonus request cannot be processed right now.",
    "2716": "You already have a pending bonus request.",
    "2717": "You do not have enough net loss (deposits minus withdrawals) for this bonus.",
    "2718": "You have already used the welcome bonus.",
    "2719": "The time limit for requesting the deposit bonus has expired.",
    "2720": "The payment service cannot connect. Please contact support.",
    "2721": "This payment service is temporarily unavailable. Please contact support.",
    "2722": "This payment service is not ready. Please contact support.",
    "2723": "The payment service could not verify the request. Please contact support.",
    "2724": "The payment request contains invalid information. Please check your details.",
    "2725": "Enter the payment amount as a whole TRY amount.",
    "2726": "The payment amount is outside the allowed limits.",
    "2727": "Enter a valid IBAN for the withdrawal.",
    "2728": "The selected payment method could not be found. Please contact support.",
    "2729": "The selected payment method is unavailable on this site.",
    "2730": "The selected payment method is currently inactive.",
    "2731": "Deposits are unavailable with this payment method.",
    "2732": "Withdrawals are unavailable with this payment method.",
    "2733": "This payment method is not supported.",
    "2734": "This payment method does not support withdrawals.",
    "2735": "This payment method does not support direct bank details.",
    "2736": "Direct bank details are unavailable. Use the payment page.",
    "2737": "This deposit has already ended. Check your transaction history.",
    "2738": "This card deposit has already ended. Check your transaction history.",
    "2739": "This withdrawal has already ended. Check your transaction history.",
    "2740": "The payment reference conflicts with another transaction. Please contact support.",
    "2741": "The payment reference conflicts with a card transaction. Please contact support.",
    "2742": "The payment reference conflicts with a withdrawal. Please contact support.",
    "2743": "You have an unfinished payment. Wait for it to finish or expire.",
    "2744": "The payment provider cannot process this withdrawal right now. Please contact support.",
    "2745": "The payment provider does not allow transactions for your account. Please contact support.",
    "2746": "The amount exceeds the direct deposit limit. Use the payment page.",
    "2747": "No suitable bank account is available right now. Please try again later.",
    "2748": "The payment has expired. Check your transaction history before starting another.",
    "2749": "This payment can no longer be changed. Check your transaction history.",
    "2750": "An amount has already been entered for this payment. Continue the existing transaction.",
    "2751": "The payment provider could not find this transaction. Please contact support.",
    "2752": "The payment service did not respond in time. Check the result of your existing transaction.",
    "2753": "The payment service could not be reached. Check the result of your existing transaction.",
    "2754": "The payment service response could not be verified. Please contact support.",
    "2755": "The payment request contains invalid information. Please check your details.",
    "2756": "This payment service is not ready. Please contact support.",
    "2757": "The payment service address could not be verified. Please contact support.",
    "2758": "The payment page address could not be verified. Please contact support.",
    "2759": "The payment service transaction details do not match. Please contact support.",
    "2760": "The payment service could not process the request. Please contact support.",
    "2761": "Bonus rules",
    "2762": "General rules",
    "2763": "Loading rules…",
    "2764": "General rules could not be loaded. Please try again.",
    "2765": "Spin the wheel · ##credits## spins",
    "2766": "You have ##credits## spins",
    "2767": "SPORTS BROADCASTS",
    "2768": "WATCH MATCHES",
    "2770": "Full screen",
    "2771": "Exit full screen",
    "2772": "Add to favorites",
    "2773": "Remove from favorites",
    "2774": "My favorites",
    "2775": "No favorite games yet",
    "2776": "Opening game…",
    "2777": "The game is taking longer to open. Please wait a little longer.",
    "2778": "Favorites are saved in this browser for this site and player.",
    "2779": "Game player",
    "2781": "The new tab was blocked. Allow pop-ups in your browser and try again.",
    "2782": "The game area is too small. The game will restart automatically when you enlarge it.",
    "2800": "AI Assistant",
    "2801": "Open assistant",
    "2802": "Close assistant",
    "2803": "Minimize",
    "2804": "Information",
    "2805": "Settings",
    "2806": "Hello, I’m listening.",
    "2807": "How can I help?",
    "2808": "Send",
    "2809": "Start now",
    "2810": "or",
    "2811": "What can I do?",
    "2812": "Bonuses",
    "2813": "Payments",
    "2814": "Games",
    "2815": "Account",
    "2816": "Help center",
    "2817": "Find games",
    "2818": "Promotions",
    "2819": "Deposit",
    "2820": "Withdraw",
    "2821": "My bonuses",
    "2822": "My transactions",
    "2823": "My account",
    "2824": "Security",
    "2825": "New conversation",
    "2826": "Preparing a reply…",
    "2827": "Could not get a reply. You can try again.",
    "2828": "Try again",
    "2829": "Chat is currently unavailable. You can continue with the menus below.",
    "2830": "Write your message",
    "2831": "Conversation history is kept only for this page session.",
    "2832": "Account operations are completed in the existing secure screens.",
    "2833": "You do not need to sign in for general questions.",
    "2834": "OK",
    "2835": "Hello, I’m here whenever you need me.",
    "2836": "Open conversation",
    "2837": "##count## / 1000 characters",
    "2838": "Messages",
    "2839": "Do not enter personal information or passwords in chat.",
    "2840": "You confirm payment operations.",
    "2841": "You reached the message limit.",
    "2842": "Conversation",
    "2843": "##count## replies remaining",
    "2844": "My balance",
    "2845": "Balance",
    "2846": "Bonus balance",
    "2847": "Recent transactions",
    "2848": "Active bonuses",
    "2849": "Loading information…",
    "2850": "Could not load information.",
    "2851": "No records found.",
    "2852": "This information is not sent to the AI service.",
    "2853": "Updated",
    "2854": "Status",
    "2855": "Amount",
    "2856": "Date",
    "2857": "Chat messages are sent to DeepSeek. Account cards are not shared.",
} as const;

export default en;
